import React from 'react';
import Tool, {
  type ToolArgs,
  type ToolArgsWithController,
} from '../../../tools/Tool';
import TableUtils from '../TableUtils';
import { type Editor, Node, Transforms } from 'slate';
import { type TableElement } from '../../../types/aha-editor';
import ColorUtils from '../../../util/color';
import TableBorderColorToolbarComponent from '../components/TableBorderColorToolbarComponent';

const getCurrentColor = (editor: Editor): undefined | string => {
  const path = TableUtils.currentTablePath(editor);
  if (!path) return;

  const node = Node.get(editor, path) as TableElement;
  const color = node.table_borderColor;

  if (color) {
    return ColorUtils.mapColorFromColorPickerToDarkMode(color);
  }
};

class ToolTableBorderColor extends Tool {
  static toolName = 'Table border color';

  static action(args: ToolArgs) {
    const { editor } = args;

    const tablePath = TableUtils.currentTablePath(editor);
    if (!tablePath) return;

    if (args.color) {
      Transforms.setNodes(
        editor,
        { table_borderColor: args.color },
        { at: tablePath }
      );
    } else {
      Transforms.unsetNodes(editor, 'table_borderColor', {
        at: tablePath,
      });
    }
  }

  static renderToolbarComponent(toolArgs: ToolArgsWithController): JSX.Element {
    const { editor, controller } = toolArgs;

    const setBorderColor = (color?: string) => {
      ToolTableBorderColor.action({
        editor,
        controller,
        color,
      });
    };

    return (
      <TableBorderColorToolbarComponent
        editor={editor}
        getBorderColor={() => getCurrentColor(editor)}
        setBorderColor={setBorderColor}
        active={this.isActive(toolArgs)}
        enabled={this.isEnabled(toolArgs)}
      />
    );
  }
}

export default ToolTableBorderColor;
